package dev.danko.roblox_craft_ai.shared.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class HealthComponent(
    val status: String,
    val latency_ms: Long? = null,
    val message: String? = null,
    val details: JsonElement? = null
)

@Serializable
data class HealthResponse(
    val status: String,
    val uptime_seconds: Long,
    val timestamp_utc_millis: Long,
    val components: Map<String, HealthComponent>
)

object HealthConstants {
    const val STATUS_OK = "OK"
    const val STATUS_DEGRADED = "DEGRADED"
    const val STATUS_DOWN = "DOWN"

    val COMPONENT_NAMES = listOf(
        "liveness",
        "llm.glm-5.3-flash",
        "llm.gemini-3.7",
        "llm.registry",
        "rbxm.builder",
        "storage.disk"
    )
}
